import $ from "jquery";

const init = () => {
  const options = {
    scrollBtn: ".js-scroll-top"
  };

  $(options.scrollBtn).click(() => {
    $("html, body").animate(
      {
        scrollTop: 0
      },
      600,
      () => {
        $("body")
          .attr("tabindex", "-1")
          .focus();
      }
    );
    return false;
  });
};

export { init };
